import Vue from 'vue';
import Vuex from 'vuex';
//root级mutations
import mutations from './mutations'
//root级actions
import actions from './actions'
//root级getters
import getters from './getters'

Vue.use(Vuex);

const state = {//公共变量
	isLoading:false,
	user: null,
};

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
	modules:{
		
	}
})
